/* eslint-disable no-underscore-dangle */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/**
 * #######################################################@
 *
 * Skills chart settings
 *
 * #######################################################@
 */
import "./style.css";

import {
	Autocomplete,
	Box,
	Chip,
	DialogActions,
	DialogContent,
	Divider,
	Icon,
	IconButton,
	ListItemButton,
	ListItemIcon,
	Menu,
	MenuItem,
	Modal,
	TextField
} from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import MDButton from "components/Basics/MDButton";
import MDBox from "components/Basics/MDBox";
import { t } from "i18next";
import i18n from "i18n";
import lod_ from "lodash";

import { useDispatch, useSelector } from "react-redux";

import { deleteFileFromPath } from "helpers/s3";
import { generateRandomCode, slugify } from "helpers/utilities";
import { socket } from "redux-react/middleware/ws";
import { useMaterialUIController } from "context";
import FormAction from "redux-react/actions/formAction";
import { display } from "redux-react/reducers/snackBarReducer";
import MDTypography from "components/Basics/MDTypography";
import MDInput from "components/Basics/MDInput";
import InputBoolean from "components/Custom/LittleForm/Inputs/InputBoolean";
import Alternative from "./components/Alternative";
import { ANSWERS_FORMAT, DOCUMENT_TYPE, TYPE, answerTypes } from "./constants";
import RightPannel from "./components/RightPannel";
import TipBar from "./components/TipBar";
import ChannelTag from "./components/ChannelTag";
import ChannelOptionRender from "./components/ChannelOptionRender";
import useMapDictionary from "hooks/useMapDictionary";
import SelectMenuTypology from "components/Custom/SelectMenuTypology";
import MDDatePicker from "components/Basics/MDDatePicker";
import NewsCategoriesDialog from "./components/DialogColorCategory";
import Languages from "flatpickr/dist/l10n/index";
import SelectMenuStep from "components/Custom/SelectMenuStep/SelectMenuStep";

/**
 * Dialog to create or edit an answer type
 * @returns
 */
export default function AnswerTypeDialog({
	open,
	dictionary,
	handleClose,
	handleSave,
	allowedChannels,
	channelType,
	channels,
	answerItem: answerItemCode = null,
	newsItems,
	//
	extra = {},
	// New props
	displayNameInput = true,
	displayDescriptionInput = true,
	displayActiveInput = true,
	displayAlternativePannel = true,
	displayChannelsInput = true,
	displayCategoriesInput = true,
	displayCockpitInput = true,
	displayTipBar = true
}) {
	// First element in the list to select all channels
	const ALL_CHANNELS = {
		code: "ALL",
		name: t("COMPONENT.ANSWERTYPE.allChannels"),
		description: t("COMPONENT.ANSWERTYPE.allChannels"),
		icon: "message"
	};

	const dispatch = useDispatch();
	const { existingKeys } = useMapDictionary(dictionary);
	const [controller] = useMaterialUIController();
	const { darkMode } = controller;
	/**
	 * Use to store new attachments.
	 * If user close the dialog without saving, we will delete the attachments
	 */
	const [temporaryAttachments, setTemporaryAttachments] = useState([]);

	// Boolean variables (active answer / display answer in cockpit)
	const [active, setActive] = useState(true);
	const [cockpit, setCockpit] = useState(true);

	// Identification variables
	const [code, setCode] = useState("");
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");

	const [typologySelected, setTypologySelected] = useState("text");
	const [stepTypeSelected, setStepTypeSelected] = useState("pitch");

	// Categories variables
	const [categories, setCategories] = useState([]);
	const [categoriesInput, setCategoriesInput] = useState("");
	const [selectedCategories, setSelectedCategories] = useState([]);

	// Editing element (if we are editing an existing answer)
	const [editingElement, setEditingElement] = useState({});

	// Channels variables
	const [channelsList, setChannelsList] = useState([]);
	const [selectedChannels, setSelectedChannels] = useState([]);

	const [generateAnswerConfiguration, setGenerateAnswerConfiguration] = useState({});

	// Selected alternative
	const [selectedAlternative, setSelectedAlternative] = useState(0);

	// Right menu pannel
	const [rightMenuPannel, setRightMenuPannel] = useState({
		open: false
	});

	// Add a single empty item for the first alternative
	const [alternatives, setAlternatives] = useState([{}]);
	// Advanced settings menu
	const [alternativeOptionMenu, setAlternativeOptionMenu] = useState({ open: null });

	// Languages
	const [languages, setLanguages] = useState([]);

	// Loading
	const [loading, setLoading] = useState(true);

	const [publishDate, setPublishDate] = useState(new Date());

	const [openCategoriesDialog, setOpenCategoriesDialog] = useState(false);

	const { profile } = useSelector(state => state);

	// Réinitialiser le champ text lorsque la typologie change vers survey ou solution
	useEffect(() => {
		if (
			(channelType === TYPE.conversational && typologySelected !== "text") ||
			(channelType === TYPE.steps && stepTypeSelected === "solution")
		) {
			setAlternatives(prevAlternatives => {
				const newAlternatives = lod_.cloneDeep(prevAlternatives);
				newAlternatives.forEach(alternative => {
					Object.keys(alternative).forEach(lang => {
						if (alternative[lang]?.text) {
							delete alternative[lang].text; // Supprimer le champ text
						}
					});
				});
				return newAlternatives;
			});
		}
	}, [channelType, typologySelected, stepTypeSelected]);

	/**
	 * Add a new attachment to the temporary attachments
	 * Called by the child component Alternative
	 * @param {Object} attachment
	 * @param {String} alternativeIndex
	 */
	const addNewAttachment = (attachment, alternativeIndex) => {
		setTemporaryAttachments(prev => {
			let newAttachments = lod_.cloneDeep(prev);
			newAttachments.push({ attachment, alternativeIndex });
			return newAttachments;
		});
	};

	/**
	 * Delete all temporary attachments
	 * @param {String?} indexToDelete delete attachments for one alternative (by index)
	 * if nothing pass, delete all temporary attachemnts
	 */
	const clearTemporaryAttachments = async (indexToDelete = null) => {
		// Clear all attachments
		for (let item of temporaryAttachments) {
			let { attachment, alternativeIndex } = item;
			// Delete only if
			// - indexToDelete is null
			// - indexToDelete is equal to the alternativeIndex (when user delete an alternative)
			if (!indexToDelete || indexToDelete === alternativeIndex) {
				await deleteFileFromPath({ key: attachment.key });
			}
		}
	};

	/**
	 * If user can click on submit button
	 * @returns boolean
	 */
	const canUserSave = () => {
		if (displayNameInput && !name?.trim()) return false;
		// IF WANT REQUIRED DESCRIPTION DECOMMENT THIS LINE
		// if (!description?.trim()) return false;
		if (displayChannelsInput && selectedChannels.length === 0) return false;
		if (alternatives.length < 1) return false;
		// check is there is at least one alternative with a text
		let hasText = alternatives.find(item => {
			let keys = Object.keys(item);
			let hasText = keys.find(key => item[key].text !== null && item[key].text?.trim() !== "");
			return Boolean(hasText);
		});
		if (!hasText) return false;

		return true;
	};

	/* Close modale */
	const close = async (e, reason) => {
		await clearTemporaryAttachments();
		handleClose();
	};
	/* Submit answer type */
	/* Submit answer type */
	/* Submit answer type */
	const submit = () => {
		// Clean alternatives
		let cleanedAlternatives = [];

		alternatives.map(item => {
			let isActive = false;
			let cleanedItem = lod_.cloneDeep(item); // Cloner l'alternative pour modifications
			let keys = Object.keys(cleanedItem);

			keys.forEach(key => {
				let object = cleanedItem[key];

				// Déterminer si l'alternative est active en fonction de la typologie
				if (channelType === TYPE.conversational) {
					if (typologySelected === "text") {
						if (object?.text && object.text.trim() !== "") {
							isActive = true;
						}
					} else if (typologySelected === "menu") {
						if (object?.menu) {
							isActive = true;
							delete object.text; // Supprimer text pour survey
						}
					} else if (
						object?.contact ||
						object?.location ||
						object?.link ||
						object?.document ||
						object?.locationRequest ||
						object?.attachments
					) {
						isActive = true;
						delete object.text; // Supprimer text pour les autres typologies
					}
				} else if (channelType === TYPE.steps) {
					if (stepTypeSelected === "pitch") {
						if (object?.text && object.text.trim() !== "") {
							isActive = true;
						}
					} else if (stepTypeSelected === "solution") {
						if (object?.menu) {
							isActive = true;
							delete object.text; // Supprimer text pour solution
						}
					}
				} else if (channelType === TYPE.ticket || channelType === TYPE.news) {
					if (object?.text && object.text.trim() !== "") {
						isActive = true;
					}
					object.subject = object.subject || "";
					object.attachments = object.attachments || [];
				} else if (channelType === TYPE.themeQuestion) {
					if (object?.question && object.question.trim() !== "") {
						isActive = true;
					}
				} else if (object?.text && object.text.trim() !== "") {
					isActive = true;
				}

				// Remplacer les mentions dans le texte, si pertinent
				if (
					object?.text &&
					(channelType !== TYPE.conversational || typologySelected === "text") &&
					(channelType !== TYPE.steps || stepTypeSelected === "pitch")
				) {
					existingKeys.forEach(keyItem => {
						object.text = object.text.replaceAll(
							`<span class="mention-tag" data-inline-content-type="mention" data-user="${keyItem.value}">${keyItem.value}</span>`,
							`{{{ ${keyItem.variable} }}}
  `
						);
					});
				}
			});

			if (isActive) {
				cleanedAlternatives.push(cleanedItem);
			}
		});

		// Déterminer le format en fonction du channelType et du contexte
		let format;
		let newPublishedDate;

		if (channelType === TYPE.news) {
			newPublishedDate =
				publishDate instanceof Date ? publishDate : new Date(publishDate || Date.now());
			format = ANSWERS_FORMAT.htmltext;
		} else if (channelType === TYPE.ticket) {
			format = ANSWERS_FORMAT.htmltext;
		} else if (channelType === TYPE.steps) {
			format = stepTypeSelected === "pitch" ? ANSWERS_FORMAT.htmltext : ANSWERS_FORMAT.menu;
		} else if (channelType === TYPE.conversational) {
			if (Boolean(answerItemCode)) {
				format =
					typologySelected && answerTypes.some(answer => answer.type === typologySelected)
						? typologySelected
						: ANSWERS_FORMAT.richtext;
			} else {
				format =
					typologySelected === "text"
						? ANSWERS_FORMAT.richtext
						: typologySelected || ANSWERS_FORMAT.richtext;
			}
		} else {
			format = ANSWERS_FORMAT.richtext;
		}

		// Create answer object
		let answer = {
			documentType: DOCUMENT_TYPE.answerType,
			code,
			format,
			type: channelType,
			channelType,
			...(channelType === TYPE.steps && { subType: stepTypeSelected }),
			//
			name,
			description,
			//
			channelsCode: selectedChannels.map(item => item.code),
			content: cleanedAlternatives,
			//
			categories:
				channelType === TYPE.news
					? selectedCategories.map(cat => ({
							code: cat.code,
							name: cat.name,
							color: cat.color,
							answerItemCategoryId: cat._id
						}))
					: selectedCategories,
			version: "2.0",
			active,
			cockpit,
			publishDate: newPublishedDate,
			...extra
		};

		const content = answer.content[0];
		const firstContent = content[Object.keys(content ?? {})[0]];

		if (!displayNameInput) {
			answer.name = firstContent?.text || firstContent?.question;
		}

		if (!displayDescriptionInput) {
			answer.description = firstContent?.text || firstContent?.question;
		}

		let options = {
			attachments: false,
			custom: false,
			api: false,
			simpleText: true
		};

		let stringifiedContent = JSON.stringify(answer.content);
		if (stringifiedContent.includes("{{{ CUSTOM")) {
			options.custom = true;
		}
		if (stringifiedContent.includes("{{{ API")) {
			options.api = true;
		}

		answer.options = options;

		const onSuccess = res => {
			handleSave(res?.item, Boolean(answerItemCode));
		};

		let data = { values: answer, target: "answerItem", unique: [] };

		if (channelType === TYPE.themeCategory || channelType === TYPE.themeQuestion) {
			data.actions = ["emptyCacheTheme"];
		}

		if (channelType === TYPE.themeQuestion && answerItemCode) {
			data.actions.push("trainThemeQuestionsKnowledge");
		}

		if (answerItemCode) {
			dispatch(FormAction.updateItem(editingElement._id, data, onSuccess));
		} else {
			dispatch(FormAction.addItemEmpty(data, onSuccess));
		}
	};

	/* Delete an alternative by index */
	const deleteAlternative = index => {
		let alternativesClone = lod_.cloneDeep(alternatives);
		alternativesClone = alternativesClone.filter((item, indexItem) => indexItem !== index);
		setAlternatives(alternativesClone);
		setSelectedAlternative(index > 0 ? index - 1 : 0);
		clearTemporaryAttachments(index);
	};

	/**
	 * Duplicate an alternative by index
	 * @param {Int} index The index of the alternative
	 */
	const duplicateAlternative = index => {
		let alternativesClone = lod_.cloneDeep(alternatives);
		let alternative = lod_.cloneDeep(alternativesClone[index]);
		alternativesClone.push(alternative);
		setAlternatives(alternativesClone);
	};

	/**
	 * Change the value of a field for an alternative
	 * @param {Int} index The index of the alternative
	 * @param {String} language The language of the alternative
	 * @param {String} path The path of the value to change
	 * @param {*} value The new value
	 */
	const changeAlternativePath = (index, language, path, value) => {
		setAlternatives(prevAlternatives => {
			// Create a deep copy of the alternatives
			const newAlternatives = lod_.cloneDeep(prevAlternatives);

			// Check if the index exists in the array, if not, create it
			if (!newAlternatives[index]) {
				newAlternatives[index] = {};
			}

			// Check and initialize the language
			if (!newAlternatives[index][language]) {
				newAlternatives[index][language] = {};
			}

			// Set the value in the new alternatives
			newAlternatives[index][language][path] = value;

			return newAlternatives;
		});
	};

	/**
	 * Get only the channels that are allowed by the channelType
	 */
	const setChannelsByChanneType = () => {
		let filteredChannels = [];

		// 1- Filter channels by channelType
		for (let channel of channels) {
			let isAllowed = allowedChannels.find(
				item => item.type === channel.type && item.subType === channel.subType
			);
			if (isAllowed) {
				channel.channelType = isAllowed.channelType;
				filteredChannels.push(channel);
			}
		}

		// 2- Add extra elements
		let extra = [
			ALL_CHANNELS,
			{
				type: "divider"
			}
		];

		let completeChannels = [...extra, ...filteredChannels];

		// 3- Set the channels list
		setChannelsList(completeChannels);

		// 4- If we are editing an element, set the selected channels
		if (editingElement && !lod_.isEmpty(editingElement)) {
			let channels = [];

			for (let channel of editingElement?.channelsCode || []) {
				let found = completeChannels.find(c => c.code === channel);
				if (found) {
					channels.push(found);
				}
			}

			setSelectedChannels(channels);
		}
	};

	/**
	 * Select / add a category in the Autocomplete component
	 * Send a WS event to add the category in the database
	 * @param {String} option the category to add
	 */
	const selectOption = option => {
		let find = categories.find(item => item === option);
		if (!find) {
			// Add category to database
			socket.emit("answer_item_add_category", { category: option });
		}
	};

	/**
	 * Result of the selectOption function, sended by the WS
	 * Add the category to the categories list
	 * @param {Object} { category } The category to add
	 */
	const selectOptionResult = ({ category }) => {
		setCategories(prev => {
			return [...prev, category];
		});
	};

	/**
	 * Delete a category from the categories list in the Autocomplete component
	 * Send a WS event to delete the category from the database
	 * @param {String} category the category to delete
	 */
	const deleteCategory = category => {
		socket.emit("answer_item_delete_category", { category });
	};

	/**
	 * Result of the deleteCategory function, sended by the WS
	 * Delete the category from the categories list
	 * @param {Object} { category } The category to delete
	 */
	const deleteCategoryResult = ({ category }) => {
		let newCategories = lod_.cloneDeep(categories).filter(item => item !== category);
		setCategories(prev => {
			return newCategories;
		});
	};

	/**
	 * Load the answer type
	 */
	useEffect(() => {
		setLoading(true);
		// Reset all var
		setActive(true);
		setCockpit(true);
		setName("");
		setDescription("");
		setSelectedChannels([ALL_CHANNELS]);
		setAlternatives([{}]);
		setEditingElement({});
		setSelectedCategories([]);
		setTemporaryAttachments([]);
		setPublishDate(null);

		setSelectedAlternative(0);

		// Reset UX
		setRightMenuPannel({ open: false });

		// Get categories
		dispatch(
			FormAction.getItemsFromCollection(
				"answerItem",
				{
					query: {
						documentType: "answerItemCategories"
					}
				},
				res => {
					let result = res.items;
					if (result?.length > 0 && result[0]?.categories) {
						setCategories(result[0].categories);
					}
				}
			)
		);

		// Get all possible languages
		dispatch(
			FormAction.getItemsFromCollection(
				"language",
				{
					query: {
						label: { $in: [null, false] }
					},
					sort: {
						default: -1
					}
				},
				res => {
					let result = res.items;
					setLanguages(result);
				}
			)
		);

		// For each channel, check if it is in the allowed channels'list by channel.type && channel.subType
		setChannelsByChanneType();

		if (channelType === TYPE.news) {
			dispatch(
				FormAction.getItemsFromCollection(
					"answerItemCategory",
					{
						query: {
							assistantID: profile.selectedAssistant.assistantID
						}
					},
					res => {
						setCategories(res.items || []);
					}
				)
			);
		}

		if (open) {
			if (answerItemCode) {
				// If we are editing an element, get the element from the database
				dispatch(
					FormAction.getItemsFromCollection(
						"answerItem",
						{
							query: {
								code: answerItemCode,
								active: { $in: [true, false, null] }
							}
						},
						res => {
							let items = res?.items ?? [];

							if (items.length > 0) {
								let item = items[0];

								let channels = [];

								for (let channel of item.channelsCode) {
									let found = channelsList.find(c => c.code === channel);
									if (found) {
										channels.push(found);
									}
								}

								setEditingElement(item);

								setCode(item.code);
								setActive(item.active ?? false);
								setCockpit(item.cockpit ?? false);
								setName(item.name);
								// setTypologySelected(item?.format);
								setDescription(item.description);
								setSelectedChannels(channels);
								setAlternatives(item.content);

								// Fetch categories for news type
								if (channelType === TYPE.news && item.categories?.length > 0) {
									const categoryCodes = item.categories.map(cat =>
										typeof cat === "string" ? cat : cat.code
									);
									dispatch(
										FormAction.getItemsFromCollection(
											"answerItemCategory",
											{
												query: {
													code: { $in: categoryCodes }
												}
											},
											res => {
												setSelectedCategories(res.items || []);
												const updated = res.items.map(cat => {
													const original = item.categories.find(c => c.code === cat.code);
													return {
														...cat,
														color: original?.color ?? cat.color,
														name: original?.name ?? cat.name
													};
												});
												setSelectedCategories(updated);
											}
										)
									);
								} else {
									setSelectedCategories(item.categories ?? []);
								}

								setPublishDate(item.publishDate || null);
								setLoading(false);
								setTypologySelected(
									item?.format === ANSWERS_FORMAT.richtext
										? "text"
										: item?.format && answerTypes.some(answer => answer.type === item.format)
											? item.format
											: "text"
								);
								setStepTypeSelected(item?.subType || "pitch");
							} else {
								dispatch(
									display({
										message: t("COMPONENT.ANSWERTYPE.cannotLoadAnswerType"),
										type: "error"
									})
								);
								handleClose();
							}
						}
					)
				);
			} else {
				// If we are creating a new element, generate a new code
				if (name.trim()) {
					setCode(`${slugify(name)}_${generateRandomCode()}`);
				} else {
					setCode(`${generateRandomCode(4)}_${generateRandomCode(4)}_${generateRandomCode(4)}`);
				}
				setLoading(false);
			}
		}
	}, [open]);

	/**
	 * WS events
	 */
	useEffect(() => {
		socket.on("answer_item_delete_category_result", deleteCategoryResult);
		socket.on("answer_item_add_category_result", selectOptionResult);
		socket.on("news_category_updated", updatedCategory => {
			setCategories(prev =>
				prev.map(cat => (cat._id === updatedCategory._id ? updatedCategory : cat))
			);
		});

		socket.on("news_category_deleted", ({ categoryId }) => {
			setSelectedCategories(prev => prev.filter(cat => cat._id !== categoryId));
			setCategories(prev => prev.filter(cat => cat._id !== categoryId));
		});

		return () => {
			socket.off("answer_item_delete_category_result", deleteCategoryResult);
			socket.off("answer_item_add_category_result", selectOptionResult);
			socket.off("news_category_updated");
			socket.off("news_category_deleted");
		};
	}, [categories]);

	useEffect(() => {
		const possibleChannel = channelsList.filter(
			channel => channel.code !== "ALL" && channel.type !== "divider"
		);

		if (selectedChannels.length <= 0 || possibleChannel.length <= 0) {
			return;
		}

		let firstChannelCode = selectedChannels[0].code;
		if (firstChannelCode === "ALL") {
			firstChannelCode = possibleChannel[0].code;
		}

		dispatch(
			FormAction.getItemsFromCollection(
				"channel",
				{
					query: {
						code: { $in: possibleChannel.map(channel => channel.code) },
						answerGenerateConfig: { $exists: true }
					},
					projection: {
						_id: 0,
						code: 1,
						answerGenerateConfig: 1
					}
				},
				res => {
					if (res.items.length <= 0) {
						return;
					}

					let possibleFirstConfig = res.items.find(item => item.code === firstChannelCode);
					if (lod_.isNil(possibleFirstConfig)) {
						possibleFirstConfig = res.items[0];
					}

					setGenerateAnswerConfiguration(possibleFirstConfig.answerGenerateConfig);
				}
			)
		);
	}, [selectedChannels, open]);

	const alternativeMemoize = useMemo(
		() => alternatives?.find((item, index) => index === selectedAlternative),
		[alternatives, selectedAlternative]
	);

	if (loading) {
		return null;
	}

	const DefaultLanguage = Languages[i18n.language] || Languages.en;

	return (
		<Modal open={open} onClose={close} disableBackdropClick disableEscapeKeyDown>
			<MDBox
				p={1}
				sx={{
					height: "100%",
					width: "100%",
					display: "flex",
					flexDirection: "row"
				}}
			>
				<MDBox
					bgColor="white"
					borderRadius="md"
					style={{
						transition: "all 0.5s ease",
						overflow: "auto",
						width: rightMenuPannel.open ? "75%" : "100%"
					}}
					display="flex"
					flexDirection="column"
				>
					<DialogContent
						sx={{
							display: "flex",
							flexDirection: "column"
						}}
					>
						{/* Display tip bar on top of dialog */}
						{displayTipBar && channelType !== TYPE.steps && <TipBar />}

						{/* Top menu */}
						<MDBox>
							{/* Answer's name */}
							<MDBox display="flex" flexDirection="row" alignItems="stretch">
								{displayNameInput && (
									<TextField
										sx={{ flex: 2 }}
										fullWidth
										placeholder={
											channelType === TYPE.news
												? t("COMPONENT.ANSWERTYPE.newsName")
												: t("COMPONENT.ANSWERTYPE.answerName")
										}
										value={name}
										onChange={e => setName(e.target.value)}
										InputProps={{
											// disableUnderline: true,
											style: {
												fontSize: "1.5rem",
												color: "#344767",
												fontWeight: "700",
												letterSpacing: "0.00735em",
												opacity: "1"
											}
										}}
									/>
								)}
								{/* Active / Cockpit boolean */}
								<MDBox flex="1" display="flex" flexDirection="row" alignItems="stretch">
									{displayActiveInput && (
										<InputBoolean
											label={t("COMPONENT.ANSWERTYPE.active")}
											value={active}
											onChange={val => {
												setActive(val);
											}}
											InputProps={{
												sx: { ml: 1, flex: 1 },
												style: {
													marginTop: 0,
													whiteSpace: "nowrap"
												}
											}}
										/>
									)}
									{channelType === TYPE.news ? (
										<Box height="100%">
											<MDDatePicker
												input={{
													className: "date_input_" + (darkMode ? "dark" : "light"),
													placeholder: t("COMPONENT.ANSWERTYPE.publishedDate"),
													marginTop: 8,
													sx: {
														flex: 1,
														height: "100%",
														whiteSpace: "nowrap",
														ml: 1,
														"& .MuiOutlinedInput-root": {
															"& fieldset": {
																height: "64px"
															},
															"&:hover fieldset": {
																height: "64px"
															},
															"&.Mui-focused fieldset": {
																height: "64px"
															},
															"& input": {
																textAlign: "center",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																height: "100%",
																paddingTop: 0,
																paddingBottom: 0
															}
														},
														"& .MuiInputBase-input::placeholder": {
															textAlign: "center",
															width: "100%",
															paddingLeft: "0"
														},
														"& .MuiInputBase-root": {
															display: "flex",
															alignItems: "center",
															height: "100%"
														}
													}
												}}
												value={publishDate}
												onChange={date => setPublishDate(new Date(date[0]))}
												options={{
													enableTime: true,
													dateFormat: "d-m-Y H:i",
													time_24hr: true,
													defaultDate: new Date(),
													clickOpens: true,
													onOpen: (selectedDates, dateStr, instance) => {
														if (selectedDates.length === 0) {
															instance.setDate(new Date());
														}
													},
													minDate: "today",
													mode: "single",
													locale: {
														...DefaultLanguage
													}
												}}
											/>
										</Box>
									) : (
										displayCockpitInput &&
										channelType !== TYPE.steps && (
											<InputBoolean
												label={t("COMPONENT.ANSWERTYPE.displayInCockpit")}
												value={cockpit}
												onChange={val => {
													setCockpit(val);
												}}
												InputProps={{
													sx: { ml: 1, flex: 1 },
													style: {
														marginTop: 0,
														whiteSpace: "nowrap"
													}
												}}
											/>
										)
									)}
								</MDBox>
							</MDBox>
							{/* Answer's description */}
							{displayDescriptionInput && (
								<MDInput
									sx={{ mt: 1 }}
									placeholder={t("COMPONENT.ANSWERTYPE.description")}
									fullWidth
									value={description}
									onChange={e => setDescription(e.target.value)}
									InputProps={{
										style: {
											fontSize: "1rem",
											minHeight: 55
										}
									}}
								/>
							)}

							{/* Bottom bar */}
							<MDBox display="flex" flexDirection="row" alignItems="stretch" sx={{ mt: 1 }}>
								{/* Answer channels */}
								{displayChannelsInput &&
									channelType !== TYPE.news &&
									channelType !== TYPE.steps && (
										<Autocomplete
											sx={{ pt: 1, flex: 2 }}
											disableCloseOnSelect
											value={selectedChannels}
											multiple
											id="tags-filled"
											options={channelsList}
											getOptionLabel={option => {
												return option.name;
											}}
											getOptionDisabled={option => {
												if (option.type === "divider") {
													return true;
												}

												let isSelectAll = selectedChannels.find(item => item.code === "ALL");
												if (isSelectAll) {
													return Boolean(option.code !== "ALL");
												} else if (selectedChannels.length > 0) {
													return Boolean(option.code === "ALL");
												}

												return false;
											}}
											freeSolo
											onChange={(event, newValue) => {
												setSelectedChannels(newValue);
											}}
											renderOption={(props, option) => {
												if (option.type === "divider") {
													return <Divider />;
												}

												return <ChannelOptionRender props={props} option={option} />;
											}}
											renderTags={(tags, getTagProps) => {
												return tags.map((option, index) => {
													return (
														<ChannelTag
															key={index}
															option={option}
															getTagProps={getTagProps}
															index={index}
														/>
													);
												});
											}}
											renderInput={params => (
												<MDInput {...params} label={t("COMPONENT.ANSWERTYPE.channelsChoice")} />
											)}
										/>
									)}
								{/* Categories */}
								{displayCategoriesInput && (
									<MDBox
										flex="1"
										style={{
											overflowX: "auto"
										}}
									>
										{channelType === TYPE.news && (
											<Box>
												<NewsCategoriesDialog
													open={openCategoriesDialog}
													onClose={() => setOpenCategoriesDialog(false)}
													categories={categories}
													socket={socket}
													selectedCategories={selectedCategories}
													onValidate={selected => {
														setSelectedCategories(selected);
													}}
													onCategoryDeleted={deletedCategoryId => {
														setSelectedCategories(prev =>
															prev.filter(cat => cat._id !== deletedCategoryId)
														);
													}}
													newsItems={newsItems}
												/>
												{Boolean(selectedCategories?.length) && (
													<MDBox
														sx={{
															display: "flex",
															flexWrap: "wrap",
															gap: 1,
															margin: 2,
															ml: 1,
															mb: 0
														}}
													>
														{selectedCategories.map((category, index) => (
															<Chip
																key={index}
																label={category.name}
																sx={{
																	backgroundColor: category.color,
																	color: "#fff",
																	borderRadius: "4px"
																}}
															/>
														))}
													</MDBox>
												)}
											</Box>
										)}
										{channelType !== TYPE.steps && channelType !== TYPE.news && (
											<Autocomplete
												sx={{
													pt: 1,
													flex: 1,
													ml: 1,
													height: "100%",
													"& .MuiAutocomplete-inputRoot": {
														flexWrap: "nowrap",
														height: "100%"
													},
													"& .MuiChip-root": {
														whiteSpace: "nowrap"
													}
												}}
												disableCloseOnSelect
												value={selectedCategories}
												multiple
												id="categories-filled"
												options={categories}
												freeSolo
												onChange={(event, newValue, reason, { option }) => {
													if (reason === "createOption") {
														selectOption(option);
													}
													setSelectedCategories(newValue);
													setCategoriesInput("");
												}}
												renderTags={(tags, getTagProps) => {
													return (
														<div
															style={{
																display: "flex",
																overflowX: "auto"
															}}
														>
															{tags.map((option, index) => {
																return (
																	<Chip
																		key={index}
																		label={option}
																		{...getTagProps({ index })}
																		style={{ whiteSpace: "nowrap" }}
																	/>
																);
															})}
														</div>
													);
												}}
												inputValue={categoriesInput}
												renderOption={(props, option) => {
													return (
														<MenuItem
															{...props}
															sx={{ mt: 0.5 }}
															style={{
																display: "flex",
																justifyContent: "space-between",
																alignItems: "center"
															}}
														>
															<MDBox display="flex" alignItems="center">
																{option}
															</MDBox>
															<IconButton
																size="small"
																onClick={e => {
																	e.stopPropagation();
																	deleteCategory(option);
																}}
															>
																<Icon>delete</Icon>
															</IconButton>
														</MenuItem>
													);
												}}
												renderInput={params => (
													<MDInput
														placeholder={`${t("COMPONENT.ANSWERTYPE.categories")} ...`}
														style={{
															height: "100%"
														}}
														{...params}
														label={t("COMPONENT.ANSWERTYPE.categories")}
														onChange={e => setCategoriesInput(e.target.value)}
														onBlur={e => {
															if (e.target.value) {
																selectOption(e.target.value);
																setSelectedCategories([...selectedCategories, e.target.value]);
																setCategoriesInput("");
															}
														}}
													/>
												)}
											/>
										)}
									</MDBox>
								)}
							</MDBox>
						</MDBox>

						{channelType === TYPE.conversational && (
							<MDBox marginTop={5}>
								<SelectMenuTypology
									isEdit={Boolean(answerItemCode)}
									typologySelected={typologySelected}
									onSelectTedMenuTypology={value => setTypologySelected(value)}
								/>
							</MDBox>
						)}

						{channelType === TYPE.steps && (
							<MDBox marginTop={2}>
								<SelectMenuStep
									isEdit={Boolean(answerItemCode)}
									stepTypeSelected={stepTypeSelected}
									onSelectTedMenuStep={value => {
										if (value !== stepTypeSelected) {
											setAlternatives([{}]);
											setSelectedAlternative(0);
										}
										setStepTypeSelected(value);
									}}
								/>
							</MDBox>
						)}

						{/* Alternatives box */}
						{!channelType ? (
							<MDBox
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
								sx={{ height: "100%" }}
							>
								<MDTypography variant="h6">
									{t("COMPONENT.ANSWERTYPE.selectAtLeastOneChannel")}
								</MDTypography>
							</MDBox>
						) : (
							<MDBox
								flex="1"
								mt={3}
								sx={{ width: "100%" }}
								display="flex"
								flexDirection="row"
								alignItems="stretch"
								borderRadius="md"
								style={{
									overflow: "hidden",
									position: "relative",
									border: "1px solid rgb(104, 104, 255)"
								}}
							>
								{displayAlternativePannel && channelType !== TYPE.news && (
									<MDBox
										flex="1"
										bgColor="light"
										style={{
											position: "sticky",
											top: "0px",
											borderRight: "1px solid rgb(232, 232, 238)"
										}}
									>
										<MDBox display="flex" flexDirection="column" sx={{ height: "100%" }}>
											<MDBox
												flex="1"
												style={{
													overflowY: "auto"
												}}
											>
												{alternatives.map((item, index) => {
													return (
														<ListItemButton
															key={index}
															selected={selectedAlternative === index}
															onClick={() => {
																setSelectedAlternative(index);
																setRightMenuPannel({
																	open: true,
																	alternative: index,
																	language: null,
																	languages,
																	channelType
																});
															}}
															sx={{
																"&.Mui-selected": {
																	backgroundColor: "info.main",
																	color: "white.main",
																	"&:hover": {
																		backgroundColor: "info.main"
																	}
																},
																"&.Mui-selected > *": {
																	color: "white.main"
																},
																"&:hover": {
																	backgroundColor: "info.light"
																},
																"&:hover > *": {
																	color: "white.main"
																}
															}}
															display="flex"
															justifyContent="space-between"
														>
															<MDTypography
																flex="1"
																variant="body2"
																fontWeight="bold"
																sx={{ textTransform: "capitalize", whiteSpace: "nowrap" }}
															>
																{channelType === TYPE.steps && stepTypeSelected === "pitch"
																	? `Motif ${index + 1}`
																	: channelType === TYPE.steps && stepTypeSelected === "solution"
																		? `Solution ${index + 1}`
																		: `Variante ${index + 1}`}
															</MDTypography>
															<ListItemIcon
																style={{
																	justifyContent: "end"
																}}
															>
																<IconButton
																	size="small"
																	onClick={e => {
																		e.stopPropagation();
																		e.preventDefault();
																		setAlternativeOptionMenu({
																			open: e.currentTarget,
																			alternative: index
																		});
																	}}
																>
																	<Icon
																		style={{
																			color: selectedAlternative === index ? "white" : "black"
																		}}
																	>
																		more_vert
																	</Icon>
																</IconButton>
															</ListItemIcon>
														</ListItemButton>
													);
												})}

												<Menu
													anchorEl={alternativeOptionMenu.open}
													open={Boolean(alternativeOptionMenu.open)}
													onClose={() =>
														setAlternativeOptionMenu({
															open: null,
															alternative: null
														})
													}
												>
													<MenuItem disabled style={{ opacity: 1 }}>
														<MDTypography variant="caption">
															{channelType === TYPE.steps && stepTypeSelected === "pitch"
																? `Motif ${alternativeOptionMenu.alternative + 1}`
																: channelType === TYPE.steps && stepTypeSelected === "solution"
																	? `Solution ${alternativeOptionMenu.alternative + 1}`
																	: `Variante ${alternativeOptionMenu.alternative + 1}`}
														</MDTypography>
													</MenuItem>

													<MenuItem
														disabled={channelType === TYPE.steps ? false : alternatives.length >= 5}
														onClick={() => {
															setAlternativeOptionMenu({ open: null });
															duplicateAlternative(alternativeOptionMenu.alternative);
														}}
													>
														<Icon>copy</Icon>&nbsp;{t("SETTINGS.duplicate")}
													</MenuItem>

													<MenuItem
														disabled={alternatives.length <= 1}
														onClick={() => {
															setAlternativeOptionMenu({ open: null });
															deleteAlternative(alternativeOptionMenu.alternative);
														}}
													>
														<Icon>delete</Icon>&nbsp;{t("SETTINGS.delete")}
													</MenuItem>
												</Menu>
											</MDBox>

											<MDBox p={2} align="center">
												<MDButton
													sx={{ width: "100%" }}
													variant="contained"
													color="info"
													onClick={() => {
														let alternativesClone = lod_.cloneDeep(alternatives);
														alternativesClone.push({});
														setAlternatives(alternativesClone);
													}}
													disabled={channelType === TYPE.steps ? false : alternatives.length >= 5}
												>
													{channelType === TYPE.steps && stepTypeSelected === "pitch"
														? t("COMPONENT.ANSWERTYPE.newPitch")
														: channelType === TYPE.steps && stepTypeSelected === "solution"
															? t("COMPONENT.ANSWERTYPE.newSolution")
															: t("COMPONENT.ANSWERTYPE.newAlternative")}
												</MDButton>
											</MDBox>
										</MDBox>
									</MDBox>
								)}

								<MDBox
									flex="6"
									style={{
										overflowY: "auto"
									}}
								>
									<Alternative
										code={code}
										dictionary={dictionary}
										languages={languages}
										alternativeIndex={selectedAlternative}
										channelType={channelType}
										alternative={alternativeMemoize ?? alternatives[0]}
										rightMenuPannel={rightMenuPannel}
										setRightMenuPannel={setRightMenuPannel}
										onChangePath={(index, language, path, value) => {
											changeAlternativePath(index, language, path, value);
										}}
										addNewAttachment={addNewAttachment}
										answerItemCode={answerItemCode}
										typologySelected={typologySelected}
										stepTypeSelected={stepTypeSelected}
									/>
								</MDBox>
							</MDBox>
						)}
					</DialogContent>
					<DialogActions
						style={{
							position: "sticky",
							bottom: 0,
							backgroundColor: "white"
						}}
					>
						<MDButton variant="outlined" color="info" onClick={close}>
							{t("SETTINGS.cancel")}
						</MDButton>
						<MDButton disabled={!canUserSave()} variant="contained" color="info" onClick={submit}>
							{answerItemCode ? t("SETTINGS.edit") : t("SETTINGS.add")}
						</MDButton>
					</DialogActions>
				</MDBox>
				{/* Right pannel */}
				<RightPannel
					rightMenuPannel={rightMenuPannel}
					setRightMenuPannel={setRightMenuPannel}
					alternatives={alternatives}
					selectedAlternative={selectedAlternative}
					changeAlternativePath={changeAlternativePath}
					name={name}
					description={description}
					channelType={channelType}
					generateAnswerConfiguration={generateAnswerConfiguration}
				/>
			</MDBox>
		</Modal>
	);
}
